import { useMemo } from "react"
import { PredefinedSegmentGroups } from "schema"

export function usePredefinedSegmentColors() {
  const predefinedSegmentColors = useMemo(() => {
    return {
      [PredefinedSegmentGroups.satisfaction]: {
        advocates: "positive",
        neutrals: "neutral",
        detractors: "negative",
      },
    } as Record<string, Record<string, string>>
  }, [])

  return predefinedSegmentColors
}
